// extracted by mini-css-extract-plugin
export var subtitle = "_d3-2";
export var title = "_d3-0";
export var titleNoWrap = "_d3-1";